import { BoxV2 as Box } from 'portal-commons';
import React from 'react';
import PhoneNumberInput from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';

interface PhoneInputProps {
  error?: boolean;
  placeholder?: string;
  note?: string;
  value?: string;
  onChange?: (val?: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  [key: `data-${string}`]: unknown;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  error,
  placeholder,
  note,
  value,
  onChange,
  onBlur,
  disabled = false,
  ...props
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 40,
        position: 'relative',
        mb: error ? 14 : 'unset',
        '& .PhoneInput': {
          opacity: disabled ? 0.5 : 1,
          '&.PhoneInput--focus': {
            borderColor: disabled ? '#666E71' : '#0091B3',
          },
          '& input[type="tel"]': {
            height: 40,
            boxSizing: 'border-box',
            overflow: 'hidden',
            border: '1.5px solid #666E71',
            borderRadius: '8px',
            outline: 'none',
            padding: '10.5px 14px 10.5px 8px',
            fontSize: '16px',
            color: '#333E41',
            backgroundColor: '#FFF',
            '&:empty': {
              backgroundColor: '#E6E7E7',
              border: 'none',
            },
            '&:hover': {
              '&:empty:not(:focus, :active)': {
                backgroundColor: '#CCCFD0',
              },
            },
            '&:focus, &:active, &:not([value=""])': {
              outline: 'none',
              backgroundColor: '#FFF !important',
              border: '1.5px solid #0091B3',
            },
            '&:not(:placeholder-shown):not(:focus)': {
              borderColor: '#666E71',
            },
          },
          '&.error': {
            borderColor: '#B70505',
            '& input[type="tel"]': {
              '&:focus, &:active, &:not([value=""])': {
                borderColor: '#B70505',
              },
              '&::placeholder': {
                color: '#B70505',
              },
            },
          },
        },
      }}
      data-testid={
        props['data-testid'] ? `PhoneInput-${props['data-testid']}` : undefined
      }
    >
      <PhoneNumberInput
        flags={flags}
        limitMaxLength
        international
        withCountryCallingCode
        placeholder={placeholder}
        value={value}
        onBlur={() => onBlur?.()}
        onChange={(val) => onChange?.(val)}
        className={error ? 'error' : ''}
        disabled={disabled}
      />
      {error && (
        <Box
          className="error-msg"
          sx={{
            color: '#B70505',
            fontSize: '10px',
            lineHeight: '12px',
            mt: '2px',
          }}
        >
          {note}
        </Box>
      )}
    </Box>
  );
};

export default PhoneInput;
